"use client";

import { useSSE } from "@/hooks/useSSE";

/**
 * SSE Provider component that handles the initial connection
 * This should be placed at the root level to ensure SSE stays connected
 */
export const SSEProvider = ({ children }: { children: React.ReactNode }) => {
  useSSE({
    autoConnect: true,
    autoDisconnect: false, // Never auto-disconnect
  });

  return <>{children}</>;
};
